import _ from "lodash";
import { config } from "@/config";
import { searchWebsiteCallbackAsync } from "./searchWebsiteCallbackAsync";

export const debounceSearchWebsiteCallbackAsync = _.debounce(
  searchWebsiteCallbackAsync,
  config.constants.DEBOUNCE_TIME,
);
